module.exports = __webpack_public_path__ + "static/media/S1_00001.fa6c08d0.jpg";